import { useQuery } from '@apollo/client';

import {
  GetOrderCouponsQuery,
  GetOrderCouponsQueryVariables,
} from '@notino/shared/definitions/types';

import { useResolvedVoucherDiscount } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/VoucherDiscount/useResolvedVoucherDiscount';
import { isConditionalDiscount } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/VoucherDiscount/utils';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import getOrderCouponsQuery from '../queries/getOrderCoupons.graphql';

export const useGetOrderCoupons = () => {
  const voucherDiscount = useResolvedVoucherDiscount();
  const { pd_upselling_unmet_voucher_condition } = useFeatureFlags();

  const isConditional = isConditionalDiscount(voucherDiscount);

  const {
    currentLocale: { priceDecimalPlaces },
    currentVariant: { attributes },
  } = useProductDetailContext();

  const orderCouponsInput = {
    voucherCode: isConditional
      ? attributes.ConditionalVoucherDiscount.code
      : '',
    orderSourceType: 'Web',
    priceDecimalPlaces,
  };

  const { data } = useQuery<
    GetOrderCouponsQuery,
    GetOrderCouponsQueryVariables
  >(getOrderCouponsQuery, {
    fetchPolicy: 'no-cache',
    skip: !isConditional || !pd_upselling_unmet_voucher_condition,
    variables: {
      orderCouponsInput,
    },
  });

  return {
    data,
  };
};
